import { ca } from '@cian/analytics';

export function trackActiveTabChange(label: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'NewbuildingReviews',
    label,
    name: 'oldevent',
    useLastProducts: true,
  });
}
